<template>
  <div
    id="inspire"
    class="h-screen"
  >
    <v-main class="fill-height">
      <v-container
        fluid
        class="fill-height"
      >
        <v-row
          align="center"
          justify="center"
          class="fill-height"
        >
          <v-col
            cols="12"
            sm="8"
            md="4"
          >
            <v-form
              ref="form"
              v-model="valid"
              @submit.prevent="login"
            >
              <v-card>
                <v-card-title class="bg-grey-lighten-4">
                  Prijava
                </v-card-title>
                <v-card-text>
                  <v-text-field
                    v-model="email"
                    class="mt-4"
                    prepend-icon="email"
                    name="email"
                    label="Email"
                    type="email"
                    :rules="emailRules"
                    required
                  />
                  <v-text-field
                    v-if="!emailLogin"
                    id="password"
                    v-model="password"
                    prepend-icon="lock"
                    name="password"
                    label="Geslo"
                    type="password"
                    :rules="passwordRules"
                    required
                  />
                </v-card-text>
                <v-card-actions>
                  <v-btn
                    to="/forgotten"
                    color="primary"
                    variant="text"
                    data="cy-forgotten-password-link"
                    data-cy="forgotten-password-link"
                  >
                    Pozabljeno geslo?
                  </v-btn>
                  <v-btn
                    to="/register"
                    color="primary"
                    variant="text"
                    data="cy-new-user-link"
                    data-cy="new-user-link"
                  >
                    Nov uporabnik?
                  </v-btn>
                </v-card-actions>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    data-cy="login"
                    color="primary"
                    variant="outlined"
                    :loading="loading"
                    :disabled="formSubmitted && !valid"
                    type="submit"
                  >
                    Prijavi se
                  </v-btn>
                </v-card-actions>
                <v-progress-linear
                  v-if="loading"
                  color="primary"
                  indeterminate
                />
              </v-card>
            </v-form>

            <v-dialog
              v-model="showEmailLinkWasSentDialog"
              width="500"
            >
              <v-card>
                <v-card-title>Povabilo je poteklo</v-card-title>
                <v-card-text>
                  <p>
                    Na vaš email naslov <b>{{ email }} smo poslali novo povezavo</b> s katero se lahko prijavite v SiteLOG.
                  </p>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="primary"
                    variant="text"
                    @click="showEmailLinkWasSentDialog=false"
                  >
                    Zapri
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </div>
</template>

<script>
  import router from '../router';
  import firebase from 'firebase/compat/app';

  export default {
    props: {
      emailLogin  : { type: Boolean, default: false },
      suggestEmail: { type: String, default: '' },
      companyId   : { type: String,  default: '' }
    },
    data: () => ({
      loading: false,
      drawer: null,
      valid: false,
      formSubmitted: false,
      email: '',
      password: '',
      lastErrorCode: '',
      showEmailLinkWasSentDialog: false
    }),
    computed: {
      emailRules() {
        return [
          v => !!v || 'Vnos e-pošte je obvezen',
          v => /.+@.+/.test(v) || 'Vpišite veljaven e-poštni naslov',
          v => this.lastErrorCode !== 'auth/user-not-found' || 'Uporabnik ne obstaja'
        ]
      },
      passwordRules() {
        return [
          v => !!v || 'Vpišite geslo',
          v =>
            v.length >= 6 ||
            'Geslo mora biti dolgo vsaj 6 znakov',
          v => this.lastErrorCode !== 'auth/wrong-password' || 'Napačno geslo'
        ]
      }
    },
    created() {
      if (this.suggestEmail) {
        this.email = this.suggestEmail;
      }
    },
    mounted() {
      this.$store.subscribe((mutation, state) => {
        if ('userLoggedIn' === mutation.type) {
          router.push({name: 'dashboard'});
        }
      });

      if (this.email && this.companyId) {
        this.$store.dispatch('userlogin', {
          email             : this.email,
          password          : this.password,
          emailLogin        : this.emailLogin,
          windowLocationHref: window.location.href,
          companyId         : this.companyId
        });
      }
    },
    methods: {
      async login () {
        this.formSubmitted = true;

        const validation = await this.$refs.form.validate();
        if (!validation.valid) {
          return;
        }

        this.loading = true;

        try {
          await this.$store.dispatch('userlogin', {
            email             : this.email,
            password          : this.password,
            emailLogin        : this.emailLogin,
            windowLocationHref: window.location.href,
            companyId         : this.companyId
          });
        } catch (e) {
          this.lastErrorCode = e.code;
          await this.$refs.form.validate();
          this.lastErrorCode = '';

          if (e.code === 'auth/expired-action-code' || e.code === 'auth/invalid-action-code') {
            this.showEmailLinkWasSentDialog = true;
            await this.resendLoginLink();
          }
        } finally {
          this.loading = false;
        }
      },
      async resendLoginLink() {
        await firebase
            .auth()
            .sendPasswordResetEmail(
                this.email,
                {
                  url: window.location.origin + '/login',
                  handleCodeInApp: false
                }
            )
        ;
      }
    }
  }
</script>
